// Campaign (bulk notification) form: narrates the audience live so the
// devices checkbox and the user selection never combine silently. The rules
// mirror Admin::BulkInAppNotification::Create#resolve_recipient_ids.
$(document).ready(function() {
  var devicesCheckbox = $('input[name="bulk_in_app_notification_form[only_with_devices]"][type="checkbox"]');
  if (!devicesCheckbox.length) return;

  var userIdsInput = $('[name="bulk_in_app_notification_form[user_ids]"], [name="bulk_in_app_notification_form[user_ids][]"]');
  var emailsInput = $('textarea[name="bulk_in_app_notification_form[emails]"]');
  var audienceHint = $('#bulk-notification-audience-hint');

  function hasSelection() {
    var selectedIds = userIdsInput
      .map(function() { return $(this).val(); })
      .get()
      .flat()
      .filter(Boolean)
      .join(',');
    return selectedIds.length > 0 || $.trim(emailsInput.val() || '').length > 0;
  }

  function updateAudienceHint() {
    if (!devicesCheckbox.is(':checked')) {
      audienceHint.text('It will be sent exactly to the selected users and emails.');
      return;
    }

    if (hasSelection()) {
      audienceHint.text('Only the selected users that have a registered device will receive it; the rest of the selection is skipped.');
    } else {
      audienceHint.text('No users selected: it will be sent to ALL users with a registered device.');
    }
  }

  devicesCheckbox.on('change', updateAudienceHint);
  emailsInput.on('input', updateAudienceHint);
  // The select2 picker rewrites its hidden input on every pick/removal
  $(document).on('change', '[name="bulk_in_app_notification_form[user_ids]"], [name="bulk_in_app_notification_form[user_ids][]"]', updateAudienceHint);
  updateAudienceHint();
});
